import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  changeForgetSuccessMsg: null,
  changeForgetError: null,
};

const changeForgotPasswordSlice = createSlice({
  name: "changeforgotpwd",
  initialState,
  reducers: {
      userChangeForgottenPasswordSuccess(state, action) {
          state.changeForgetSuccessMsg = action.payload
      },
      userChangeForgottenPasswordError(state, action) {
          state.changeForgetError = action.payload
      },
  },
});

export const {
  userChangeForgottenPasswordSuccess,
  userChangeForgottenPasswordError
} = changeForgotPasswordSlice.actions

export default changeForgotPasswordSlice.reducer;
